import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class ControlActivationService {
    constructor(private http: HttpClient) { }

    private _toggledUser = new BehaviorSubject<any>({});
    toggledUser = this._toggledUser.asObservable();

    setToggledUSer(user) {
        this._toggledUser.next(user);
    }

    getToggledUSer() {
        return this._toggledUser;
    }

    private _toggleUserBtn = new BehaviorSubject<any>({});
    toggleUserBtn = this._toggleUserBtn.asObservable();

    setToggleUserBtn(event) {
        this._toggleUserBtn.next(event);
    }

    getToggleUserBtn() {
        return this._toggleUserBtn;
    }
}